import { Component, OnInit } from '@angular/core';
import { InceptionService, TranslationService } from '@proximus/ng-common';
import { OnDestroyHookDirective } from 'src/app/shared/hooks';

@Component({
  selector: 'mprd-public-wifi-pxsplus-configuration',
  templateUrl: './public-wifi-pxsplus-configuration.component.html',
  styleUrls: ['./public-wifi-pxsplus-configuration.component.css'],
})
export class PublicWifiPxsplusConfigurationComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  backUrlFromApp: string;

  constructor(
    private inceptionService: InceptionService,
    private translationService: TranslationService,
  ) {
    super();
  }

  ngOnInit() {
    if (window['MyProximusMobileApp']) {
      this.backUrlFromApp = this.translationService.getTranslatedValueFor(
        'common.myproximus.back.url',
      );
    }

    setTimeout(() => {
      this.inceptionService.init();
    });
  }

  goBack() {
    this.backUrlFromApp
      ? window.open(this.backUrlFromApp)
      : window.history.back();
  }
}
